import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { MrsColor } from 'app/enums';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel, MatHint } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { NgIf } from '@angular/common';
import { MrsBtnTertiaryComponent } from '../../../../../../shared/components/mrs-buttons/mrs-btn-tertiary/mrs-btn-tertiary.component';

@Component({
    selector: 'subtitle-dialog',
    templateUrl: './subtitle-dialog.component.html',
    styleUrls: ['./subtitle-dialog.component.scss'],
    imports: [MatDialogTitle, FormsModule, ReactiveFormsModule, RxReactiveFormsModule, CdkScrollable, MatDialogContent, MatFormField, MatLabel, MatInput, NgIf, MatHint, MatDialogActions, MrsBtnTertiaryComponent]
})
export default class SubtitleDialog {
    subtitleForm: FormGroup;
    buttonColor = MrsColor.UIBlue;
    title: string;
    isEdit = false;
    msg: string;
    subtitle: string;

    constructor(
        public dialogRef: MatDialogRef<SubtitleDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private _fb: FormBuilder
    ) {
        this.title = data.title;
        this.msg = data.msg;
        this.subtitle = data.subtitle;
        this.subtitleForm = _fb.group({ subtitle: [this.subtitle] });
    }

    //#region Handlers

    updateSubtitle(): void {
        this.dialogRef.close({
            subtitle: this.subtitleForm.get('subtitle').value
        });
    }

    cancel(): void {
        this.dialogRef.close();
    }

    //#endregion
}
